<template>
  <div :class="`bottom-margin-${bottomMargin}`">
    <div :class="['field', `label-${labelPosition}`, variant]">
      <component
        :is="is"
        :for="id"
        :class="['field-label', `label-${labelPosition}`]"
      >
        {{ label }}
      </component>
      <span
        :class="[
          'field-input',
          `label-${labelPosition}`,
          id ? 'fixed' : 'free'
        ]"
      >
        <slot />
      </span>
    </div>
    <span v-if="error" class="error-text">
      {{ error }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    label: String,
    error: String,
    variant: {
      type: String,
      validator: val => ["default", "success", "error"].includes(val),
      default: "default"
    },
    labelPosition: {
      type: String,
      validator: val => ["inline", "top"].includes(val),
      default: "top"
    },
    bottomMargin: {
      type: String,
      validator: val => ["default", "small", "none"].includes(val),
      default: "default"
    }
  },
  computed: {
    is() {
      return this.id ? "label" : "span";
    }
  }
};
</script>

<style scoped lang="scss">
.field {
  display: flex;
  min-height: var(--input-height);

  &.error {
    color: var(--text-danger);
  }

  &.success {
    color: var(--text-success);
  }

  &:focus-within {
    color: var(--text-brand);
  }

  &.label-top {
    flex-direction: column;
    align-items: flex-start;
  }

  &.label-inline {
    align-items: flex-start;
    justify-content: space-between;
  }
}
.field-label {
  display: inline-block;
  flex: 0 1 auto;
  font-size: 1rem;
  font-weight: bold;
  &.label-top {
    padding-bottom: 0.1rem;
  }
  &.label-left {
    padding-right: 0.1rem;
  }

  &.label-inline {
    padding: var(--input-padding);
    padding-left: 0;
    line-height: var(--input-line-height);
  }
}
.field-input {
  display: block;
  font-size: 1rem;
  font-weight: normal;
  line-height: var(--input-line-height);

  &.label-top {
    align-self: stretch;
  }

  &.label-inline {
    align-self: flex-end;
  }

  &.label-inline.free {
    padding: var(--input-padding-v) 0;
    text-align: right;
  }

  &.label-inline.fixed {
    width: 50%;
    min-width: 12rem;
  }
}
.bottom-margin-default {
  margin-bottom: 0.5rem;
}
.bottom-margin-small {
  margin-bottom: 0.3rem;
}
.error-text {
  display: block;
  margin: 0;
  font-size: 0.8rem;
  color: var(--text-danger);
  text-align: right;
}
</style>
